import { render, staticRenderFns } from "./SearchResultNav.vue?vue&type=template&id=20ac1d43&"
import script from "./SearchResultNav.vue?vue&type=script&lang=js&"
export * from "./SearchResultNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports